import { BrowserRouter, Route, Routes } from "react-router-dom";
import Main from "../components/Main";
import Users from "../components/Users";
import OnboardCampaignUI from "../components/Onboard_Campaign";
import CampaignListUI from "../components/Campaign_List";
import MainLayout from "../components/MainLayout";
import CampaignQAResultUI from "../components/Campaign_QA_Results";
function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <MainLayout>
              <OnboardCampaignUI />
            </MainLayout>
          }
        />
        <Route
          path="/loginCallback"
          element={
            <MainLayout>
              <Main />
            </MainLayout>
          }
        />
        <Route
          path="/on_board_campaign"
          element={
            <MainLayout>
              <OnboardCampaignUI />
            </MainLayout>
          }
        />
        <Route
          path="/campaign_list"
          element={
            <MainLayout>
              <CampaignListUI />
            </MainLayout>
          }
        />
        <Route
          path="/optimise_campaign"
          element={
            <MainLayout>
              <OnboardCampaignUI />
            </MainLayout>
          }
        />
        <Route
          path="/campaign_qa_results"
          element={
            <MainLayout>
              <CampaignQAResultUI />
            </MainLayout>
          }
        />
        <Route
          path="/Users"
          element={
            <MainLayout>
              <Users />
            </MainLayout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
